const accordions = document.querySelectorAll('[data-sonic="accordion"]');
const toggles = [
  ...document.querySelectorAll('[data-sonic="collapse-all"]'),
  ...document.querySelectorAll('[data-sonic="expand-all"]'),
];
const viewMores = document.querySelectorAll('[data-sonic="accordion-view-more"]');

const collapseAll = (id) => {
  const accordion = document.querySelector(id);
  const activators = accordion.querySelectorAll('[data-sonic="accordion-activator"]');

  activators.forEach((item) => {
    if (item.classList.contains('open')) {
      item.classList.remove('open');
      item.nextElementSibling.classList.remove('open');
    }
  });
};

const expandAll = (id) => {
  const accordion = document.querySelector(id);
  const activators = accordion.querySelectorAll('[data-sonic="accordion-activator"]');

  activators.forEach((item) => {
    if (!item.classList.contains('open')) {
      item.classList.add('open');
      item.nextElementSibling.classList.add('open');
    }
  });
};

const viewMore = (e, id) => {
  const accordion = document.querySelector(id);
  const listItems = accordion.querySelectorAll('[data-sonic="accordion-hideable"]');

  listItems.forEach((listItem) => {
    listItem.classList.toggle('hidden');
  });

  if (e.target.innerHTML === 'View More') {
    e.target.innerHTML = 'View Less';
  } else {
    e.target.innerHTML = 'View More';
    e.target.scrollIntoView();
  }
};

if (accordions) {
  accordions.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (
        e.target.dataset
        && e.target.dataset.sonic
        && e.target.dataset.sonic === 'accordion-activator'
      ) {
        const activator = e.target;

        // toggle open on the activator that was clicked
        activator.classList.toggle('open');
        // toggle open on the content next to the activator that was clicked
        activator.nextElementSibling.classList.toggle('open');
      }
    });
  });
}

if (toggles) {
  toggles.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (e.target.dataset.sonic === 'collapse-all') {
        collapseAll(e.target.dataset.target);
      }

      if (e.target.dataset.sonic === 'expand-all') {
        expandAll(e.target.dataset.target);
      }
    });
  });
}

if (viewMores) {
  viewMores.forEach((item) => {
    item.addEventListener('click', (e) => {
      viewMore(e, e.target.dataset.target);
    });
  });
}
